import React, { Component } from 'react';
import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';

export default class SelectHubstaff extends Component<any> {
  static defaultProps = {
    placeholder: 'Select a Hubstaff project',
  };

  async fetchHubstaff(text: string) {
    if (!text) {
      return [];
    }
    try {
      const hubstaffOptions = await apiFetch(null, `/internal/hubstaff/projects`, {
        query: { search: text },
      });

      const options =
        hubstaffOptions?.hubstaffProject?.map((hubstaffOption: { name: string; id: string }) => ({
          label: `${hubstaffOption.name} (${hubstaffOption.id})`,
          value: hubstaffOption.id,
        })) || [];

      return { options };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return [];
    }
  }

  render() {
    return (
      <React.Fragment>
        <Select
          filterOption={() => true}
          {...this.props}
          loadOptions={this.fetchHubstaff.bind(this)}
        />
      </React.Fragment>
    );
  }
}
